import { Radio, RadioGroup } from "@nju/form";
import { Separator } from "@nju/ui";
import { ISelectedMsisdnOfferType } from "./SelectMsisdnOfferType.machine";

interface ISelectMsisdnOfferTypeForm {
  handleMsisdnOfferTypeChange(value: ISelectedMsisdnOfferType): void;
}

export function SelectMsisdnOfferTypeForm({
  handleMsisdnOfferTypeChange,
}: ISelectMsisdnOfferTypeForm) {
  return (
    <form>
      <RadioGroup
        aria-label="msisdn offer type"
        name="msisdn-offer-type"
        onValueChange={(value) => {
          handleMsisdnOfferTypeChange(value as ISelectedMsisdnOfferType);
        }}
      >
        <Radio value="PREPAID">na kartę/subskrypcja</Radio>
        <Radio value="POSTPAID">na abonament/mix</Radio>
        <Separator size="xs" tone="invisible" />
      </RadioGroup>
    </form>
  );
}
